import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudEditComponent } from '../../../../../libs/components/generic-crud/generic-crud-edit.component';
import { Checkpoint, TId, WorkProcedure, WorkProcedureStep } from '../../../../../models';
import { GenericResource } from '../../../../../resources';
import { StepsAddComponent } from '../steps-add/steps-add.component';
import { StepsEditComponent } from '../steps-edit/steps-edit.component';

@Component({
  selector: 'app-work-procedures-edit',
  templateUrl: './work-procedures-edit.component.html',
  styleUrl: './work-procedures-edit.component.sass',
  standalone: false,
})
export class WorkProceduresEditComponent extends GenericCrudEditComponent<WorkProcedure> {
  stepsAddComponent = StepsAddComponent;
  stepsEditComponent = StepsEditComponent;
  steps?: GenericResource<WorkProcedureStep>;
  checkpoints: Checkpoint[] = [];

  constructor() {
    super();
    this.resource = this.api.resources.product.workProcedures;
  }

  protected override async preFetch(): Promise<void> {
    this.steps = this.api.resources.product.workProceduresSteps(this.entity!.id);
    this.checkpoints = await firstValueFrom(this.api.resources.checkpoints.getAll());
  }

  override initFormGroup(): FormGroup<any> {
    const workProcedure: WorkProcedure = this.entity!;
    return this.fb.group({
      id: [workProcedure.id],
      name: [workProcedure.name],
      code: [workProcedure.code],
      version: [workProcedure.version],
      companyId: [workProcedure.companyId],
    });
  }

  override displayEntity(): string {
    return this.entity!.name;
  }

  getCheckpointName(id: TId | undefined): string {
    if (id == null || id === '') {
      return '';
    }
    return this.checkpoints.find(c => c.id === id)?.name ?? '';
  }

  formatDefaultValues(value: unknown, type?: number): string {
    if (value == null) {
      return '';
    }

    const formatTime = (date: Date): string => {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    };

    const formatDate = (date: Date): string => {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const formatValue = (val: unknown): string => {
      const text = String(val);
      const date = new Date(text);

      if (!isNaN(date.getTime())) {
        if (type === 7) { // Time
          return formatTime(date);
        }
        if (type === 6) { // Date
          return formatDate(date);
        }
      }

      return text;
    };

    if (Array.isArray(value)) {
      return value.map(formatValue).join(', ');
    }

    return formatValue(value);
  }
  toBoolean(value: unknown): boolean {
    if (Array.isArray(value)) {
      value = value[0];
    }

    return value === true || value === 'true' || value === '1';
  }
}
